module.exports = function() {
	var api = {};

	api.settings = {
		apiUrl : require('/app/js/objs/config').apiBaseUrl + '/v2/groupware/pxc/public/api/v1',
	};

	api.init = function() {};

	/**
	 * Login-Token (Authorization: Bearer) mitsenden. Bei 401 (Token abgelaufen oder widerrufen) zurueck zum Login.
	 * Synchron wie bisher, die Aufrufer erwarten den Rueckgabewert direkt.
	 */
	api.request = function(type, url, data, async) {
		var returnData = {};
		var token = window.store.get('apiToken');
		$.ajax({
			'async' : !!async,
			'type' : type,
			'dataType' : 'json',
			'url' : url,
			'data': data,
			'headers': token ? {'Authorization': 'Bearer ' + token} : {},
			'success' : function(data) {
				returnData = data;
			},
			'error' : function(xhr) {
				if (xhr.status === 401 && window.AppUser) {
					window.AppUser.expired();
				}
				if (xhr.responseJSON) {
					returnData = xhr.responseJSON;
				}
			}
		});
		return returnData;
	}

	api.url = function(table, id, additional) {
		var url = this.settings.apiUrl + '/' + table;
		if (id && id != false && id != 'false') {
			url = url + '/' + id;
		}
		if (additional) {
			url = url + additional;
		}
		return url;
	}

	api.put = function(table,data) {
		return this.request('PUT', this.url(table), data);
	}

	api.post = function(table,data, additional) {
		return this.request('POST', this.url(table, false, additional), data);
	}

	/**
	 * Asynchron senden, fuer das minuetliche Zwischenspeichern. callback bekommt die Antwort.
	 */
	api.postAsync = function(table, data, callback) {
		var token = window.store.get('apiToken');
		$.ajax({
			'type' : 'POST',
			'dataType' : 'json',
			'url' : this.url(table),
			'data': data,
			'headers': token ? {'Authorization': 'Bearer ' + token} : {},
			'success' : function(response) {
				if (callback) {
					callback(response);
				}
			},
			'error' : function(xhr) {
				if (xhr.status === 401 && window.AppUser) {
					window.AppUser.expired();
				}
			}
		});
	}

	api.call = function(table,id,additional) {
		return this.request('GET', this.url(table, id, additional));
	};

	api.init();
	return api;
}
